<template>
  <el-dialog :append-to-body="true" :visible.sync="isShowNotice" :show-close="false" width="520px" custom-class="custome-notice" @closed="close"  :close-on-click-modal="false" :close-on-press-escape="false">
    <a class="close-con" @click="close">
      <i class="iconfont iconshanchu"></i>
    </a>
    <h1 class="notice-title">公告（{{currentIndex + 1}}/{{data.length || 0}}）</h1>
    <div class="notice-content" v-html="content"></div>
    <div class="notice-btn clearfix" v-if="data.length > 1">
      <el-button class="floatL" v-if="currentIndex > 0" @click="currentIndex -= 1">上一条</el-button>
      <el-button class="floatR" v-if="currentIndex < data.length - 1" @click="currentIndex += 1">下一条</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'NoticeDialog',
  data () {
    return {
      isShowNotice: false,
      currentIndex: 0,
      data: []
    }
  },
  computed: {
    ...mapState({
      noticeList: state => state.const.noticeList
    }),
    content () {
      const data = this.data[this.currentIndex];
      if (!data) return '';
      if (data.extra && data.extra.text) return data.extra.text || '';
      return data.content || '';
    }
  },
  watch: {
    noticeList () {
      if (!this.isShowNotice) {
        this.data = this.noticeList;
        this.isShowNotice = this.noticeList.length !== 0;
      }
    }
  },
  methods: {
    close () {
      this.isShowNotice = false;
      this.currentIndex = 0;
    }
  }
}
</script>
<style lang="less">
.custome-notice.el-dialog{
  border-radius: 5px;
  .close-con{
    position: absolute;
    background: #FFF;
    padding: 0px;
    border-radius: 50%;
    overflow: hidden;
    right: -15px;
    top: -15px;
    cursor: pointer;
    .iconfont{
      display: block;
      font-size: 32px;
      color: #454444;
    margin-right: -1px;
    }
  }
  .el-dialog__header,.el-dialog__body{
    padding: 0;
  }
  .notice-title{
    font-size: 18px;
    color: #333333;
    text-align: center;
    line-height: 60px;
    font-weight: 400;
    padding-top: 5px;
  }
  .notice-content{
    padding: 0 34px;
    font-size: 14px;
    color: #333333;
    line-height: 25px;
    height: 290px;
    overflow-y: scroll;
  }
  .notice-btn{
    padding: 29px 34px 25px 34px;
  }
}
</style>